import { render, staticRenderFns } from "./purchase-order-receipts.vue?vue&type=template&id=7b147261&"
import script from "./js/purchase-order-receipts.js?vue&type=script&lang=js&"
export * from "./js/purchase-order-receipts.js?vue&type=script&lang=js&"
import style0 from "./purchase-order-receipts.vue?vue&type=style&index=0&id=7b147261&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports